import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogCommentComponent } from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-comment/dialog-comment.component';
import { DialogConfirmComponent } from 'src/app/+home/shared/components/dialog-confirm/dialog-confirm.component';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { UserService } from 'src/shared/services/user/user.service';
import { MOMENT_TOKEN } from '../../shared/shared.module';
import { CommentService } from '../services/comment.service';
import { RenderingQueueServices } from '../services/rendering-queue.services';
import { PdfPasswordDialogComponent } from './pdfViewer-password-dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

declare let PDFJS: any;

import * as PDFViewer from 'pdfjs-dist/web/pdf_viewer';
import * as pdfjsLib from 'pdfjs-dist';

import { DragDropSignatureDirective } from '../shared/directives/drag-drop-signature.directive';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { fromEvent, Observable, Subscription } from 'rxjs';


@Component({
  selector: 'adf-pdf-viewer',
  templateUrl: './pdfViewer.component.html',
  styleUrls: ['./pdfViewer.component.scss', './pdfViewerHost.component.scss'],
  providers: [RenderingQueueServices],
  encapsulation: ViewEncapsulation.None
})
export class PdfViewerComponent implements OnInit, OnChanges, OnDestroy {
  @HostBinding('class') adfPdfViewerClass = 'adf-pdf-viewer';
  public comments: any[];
  public questions: any[] = [];
  public commentaire: string;
  public text: string;
  public question: string;
  @Input() hideGoBack?: boolean;
  @Input() hideRightMenu?: boolean;
  @Input() elementId: string;
  @Input() properties: any;
  @Input() seeProperties: any;
  @Input() parentId: string;
  @Input() path: any;
  @Input() fileName: string;
  @Input() description: string;
  @Input()
  urlFile: string;
  @Input() creator: string;
  @Input() size: number;
  @Input() creationDate: string;
  @Input() modifier: string;
  @Input() modificationDate: string;
  @Input() type: string;
  @Input() originalMimeType: string;
  @Input() mimeType: string;
  @Input() selectedNode: any;
  @Input()
  blobFile: Blob;
  @Input()
  nameFile: string;
  @Input()
  showToolbar = true;
  @Input()
  allowThumbnails = false;
  @Input()
  thumbnailsTemplate: TemplateRef<any> = null;
  @Input()
  isPublic: boolean;
  @Output()
  rendered = new EventEmitter<any>();
  @Output()
  error = new EventEmitter<any>();
  @Output()
  exit = new EventEmitter<any>();
  public show = false;
  public buttonName: any = 'Plus...';
  loadingTask: any;
  currentPdfDocument: any;
  page: number;
  displayPage: number;
  totalPages: number;
  loadingPercent: number;
  pdfViewer: any;
  documentContainer: any;
  currentScaleMode = 'auto';
  currentScale = 1;
  MAX_AUTO_SCALE = 1.25;
  DEFAULT_SCALE_DELTA = 1.1;
  MIN_SCALE = 0.25;
  MAX_SCALE = 10.0;
  isPanelDisabled = true;
  showThumbnails = false;
  pdfThumbnailsContext: { viewer: any } = { viewer: null };
  pdfFindController = null;
  @Input() signature: any = false;
  @ViewChild(DragDropSignatureDirective) public dragDropDirective: DragDropSignatureDirective;
  @ViewChild('draggableSignature') private signatureDraggable;
  @Output() findControllerDone = new EventEmitter();
  @Input() showSearch = false;
  public searchControl: FormControl;
  public hasSearchFocus: boolean;
  public keyupSubscription: Subscription;
  @ViewChild('inputSearch', { static: true }) inputSearch;
  @ViewChild('viewerPdfViewer') viewerPdfViewer;
  @ViewChild('viewerViewerPdf') viewerViewerPdf;

  constructor(
    private dialog: MatDialog,
    private renderingQueueServices: RenderingQueueServices,
    private commentService: CommentService,
    private storage: StorageService,
    @Inject(MOMENT_TOKEN) public moment,
    private activatedRoute: ActivatedRoute
  ) {
    // private logService: LogService) {
    // needed to preserve "this" context
    this.onPageChange = this.onPageChange.bind(this);
    this.onPagerendered = this.onPagerendered.bind(this);
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.js';
  }

  get currentScaleText(): string {
    return Math.round(this.currentScale * 100) + '%';
  }

  ngOnInit() {
    // GESTION DE LA RECHERCHE
    this.searchControl = new FormControl('');

    this.searchControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounceTime(300)
      )
      .subscribe(async (newSearch) => {
        if (!newSearch) {
          this.pdfFindController.executeCommand("find", { query: '' });
          return;
        }

        this.pdfFindController.executeCommand("find", {
          query: newSearch,
          caseSensitive: false,
          highlightAll: true
        });

        await this.pdfFindController.matchesReady();
      });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (this.pdfFindController && params.search) {
        this.searchControl.setValue(params.search);
      }
    });

    this.keyupSubscription = fromEvent(document, 'keydown').subscribe((event: any) => {
      if (event.keyCode === 114 || (event.ctrlKey && event.keyCode === 70)) {
        this.inputSearch.nativeElement.focus();
        this.inputSearch.nativeElement.select();
        event.preventDefault();
      }
    });
  }

  public previousSearch() {
    const pageMatches = this.pdfFindController;
    const { pageIdx, matchIdx } = this.pdfFindController.selected;

    this.pdfFindController.nextMatch();
  }

  public nextSearch() {
    this.pdfFindController.nextMatch();
  }

  ngOnDestroy() {
    if (this.documentContainer) {
      this.documentContainer.removeEventListener(
        'pagechange',
        this.onPageChange,
        true
      );
      this.documentContainer.removeEventListener(
        'pagesloaded',
        () => { this.isPanelDisabled = false },
        true
      );
      this.documentContainer.removeEventListener(
        'textlayerrendered',
        this.onPagerendered,
        true
      );
    }

    if (this.loadingTask) {
      this.loadingTask.destroy();
    }

    this.keyupSubscription.unsubscribe();
  }

  ngOnChanges(changes) {
    const blobFile = changes['blobFile'];
    if (blobFile && blobFile.currentValue) {
      const reader = new FileReader();
      reader.onload = () => {
        this.executePdf(reader.result);
      };
      reader.readAsArrayBuffer(blobFile.currentValue);
    }

    const urlFile = changes['urlFile'];
    if (urlFile && urlFile.currentValue) {
      this.executePdf(urlFile.currentValue);
    }

    if (!this.urlFile || !this.blobFile) {
      throw new Error('Attribute urlFile or blobFile is required');
    }
  }

  async executePdf(src) {
    this.loadingTask = pdfjsLib.getDocument(src);

    this.loadingTask.onPassword = (callback, reason) => {
      this.onPdfPassword(callback, reason);
    };

    this.loadingTask.onProgress = progressData => {
      const level = progressData.loaded / progressData.total;
      this.loadingPercent = Math.round(level * 100);
    };

    try {
      const pdfDocument = await this.loadingTask.promise;

      this.currentPdfDocument = pdfDocument;

      this.totalPages = pdfDocument.numPages;
      this.page = 1;
      this.displayPage = 1;
      this.initPDFViewer(this.currentPdfDocument);
      await this.pdfViewer.pagesPromise; // Garantit le chargement des pages avant de continuer

      // Initialiser directive signature pour mettre en place le drag & drop
      this.dragDropDirective.initialize(this.viewerViewerPdf.nativeElement);
      this.dragDropDirective.makeItDraggable(this.signatureDraggable.nativeElement);
      
      this.onResize();
      // this.currentPdfDocument.getPage(1).then(
      //   async () => {
      //     await this.scalePage('auto');
      //   },
      //   error => {
      //     this.error.emit();
      //   }
      // );
    } catch (e) {
      this.error.emit();
    }
  }

  /**
   * return the PDFJS global object (exist to facilitate the mock of PDFJS in the test)
   */
  getPDFJS() {
    return (PDFViewer as any).PDFJS;
  }

  initPDFViewer(pdfDocument: any) {
    this.commentService.getAllComment(this.elementId).then(res => {
      this.comments = res.items;
    });
    // PDFJS.verbosity = 1;
    // PDFJS.disableWorker = false;

    const viewer: any = this.viewerViewerPdf.nativeElement;
    this.documentContainer = document.getElementById('viewer-pdf-viewer');
    this.documentContainer.addEventListener(
      'pagechange',
      this.onPageChange,
      true
    );
    this.documentContainer.addEventListener(
      'pagesloaded',
      () => {
        this.isPanelDisabled = false;
      },
      true
    );
    this.documentContainer.addEventListener(
      'textlayerrendered',
      this.onPagerendered,
      true

    );
    const eventBus = new PDFViewer.EventBus();
    // (Optionally) enable hyperlinks within PDF files.
    const pdfLinkService = new PDFViewer.PDFLinkService({
      eventBus,
    });
    this.pdfFindController = new PDFViewer.PDFFindController({
      eventBus,
      linkService: pdfLinkService,
    });

    // HACK, on appelle PDFViewer pour provoquer l'initialisation de la librairie et éviter une erreur !
    const pdfViewer = PDFViewer; // A GARDER !

    this.pdfViewer = new PDFViewer.PDFViewer({
      container: this.documentContainer,
      viewer: viewer,
      eventBus,
      linkService: pdfLinkService,
      l10n: null

      //renderingQueue: this.renderingQueueServices
    });

    //this.pdfViewer.setFindController(this.pdfFindController);

    // GESTION DE LA RECHERCHE
    this.pdfFindController.pdfViewer = this.pdfViewer;
    this.findControllerDone.emit(this.pdfFindController);

    this.renderingQueueServices.setViewer(this.pdfViewer);

    //this.pdfViewer.setDocument(pdfDocument);

    //this.pdfThumbnailsContext.viewer = this.pdfViewer;

    if (this.activatedRoute.snapshot.queryParams.search) {
      this.searchControl.setValue(this.activatedRoute.snapshot.queryParams.search);
    }
    this.renderingQueueServices.setViewer(this.pdfViewer);

    this.pdfViewer.setDocument(pdfDocument);

    this.pdfThumbnailsContext.viewer = this.pdfViewer;
  }

  toggleThumbnails() {
    this.showThumbnails = !this.showThumbnails;
  }

  /**
   * Method to scale the page current support implementation
   *
   * @param scaleMode - new scale mode
   */
  async scalePage(scaleMode) {
    this.currentScaleMode = scaleMode;

    if (this.pdfViewer) {
      const viewerContainer = document.getElementById('viewer-main-container');
      const documentContainer = this.viewerPdfViewer.nativeElement;

      let widthContainer;
      let heightContainer;

      if (
        viewerContainer &&
        viewerContainer.clientWidth <= documentContainer.clientWidth
      ) {
        widthContainer = viewerContainer.clientWidth;
        heightContainer = viewerContainer.clientHeight;
      } else {
        widthContainer = documentContainer.clientWidth;
        heightContainer = documentContainer.clientHeight;
      }

      const currentPage = this.pdfViewer._pages[
        this.pdfViewer._currentPageNumber - 1
      ];

      const padding = 20;
      const pageWidthScale =
        ((widthContainer - padding) / currentPage.width) * currentPage.scale;
      const pageHeightScale =
        ((heightContainer - padding) / currentPage.height) * currentPage.scale;

      let scale;


      switch (this.currentScaleMode) {
        case 'page-actual':
          scale = 1;
          break;
        case 'page-width':
          scale = pageWidthScale;
          break;
        case 'page-height':
          scale = pageHeightScale;
          break;
        case 'page-fit':
          scale = Math.min(pageWidthScale, pageHeightScale);
          break;
        case 'auto':
          let horizontalScale;
          if (this.isLandscape) {
            horizontalScale = Math.min(pageHeightScale, pageWidthScale);
          } else {
            horizontalScale = pageWidthScale;
          }
          scale = Math.min(this.MAX_AUTO_SCALE, horizontalScale);

          break;
        default:
          return;
      }
      this.setScaleUpdatePages(scale);

    }
  }

  /**
   * Update all the pages with the newScale scale
   *
   * @param newScale - new scale page
   */
  setScaleUpdatePages(newScale: number) {
    if (!this.isSameScale(this.currentScale, newScale)) {
      this.currentScale = newScale;

      this.pdfViewer._pages.forEach(function (currentPage) {
        currentPage.update(newScale);
      });
    }

    this.pdfViewer.update();
  }

  /**
   * Check if the request scale of the page is the same for avoid useless re-rendering
   *
   * @param oldScale - old scale page
   * @param newScale - new scale page
   *
   */
  isSameScale(oldScale: number, newScale: number): boolean {
    return newScale === oldScale;
  }

  /**
   * Check if is a land scape view
   *
   * @param width
   * @param height
   */
  isLandscape(width: number, height: number): boolean {
    return width > height;
  }

  /**
   * Method triggered when the page is resized
   */
  onResize() {
    this.scalePage(this.currentScaleMode);
  }

  /**
   * toggle the fit page pdf
   */
  pageFit() {
    if (this.currentScaleMode !== 'page-fit') {
      this.scalePage('page-fit');
    } else {
      this.scalePage('auto');
    }
  }

  /**
   * zoom in page pdf
   *
   * @param ticks
   */
  zoomIn(ticks?: number) {
    let newScale: any = this.currentScale;
    do {
      newScale = (newScale * this.DEFAULT_SCALE_DELTA).toFixed(2);
      newScale = Math.ceil(newScale * 10) / 10;
      newScale = Math.min(this.MAX_SCALE, newScale);
    } while (--ticks > 0 && newScale < this.MAX_SCALE);
    this.currentScaleMode = 'auto';
    this.setScaleUpdatePages(newScale);
  }

  /**
   * zoom out page pdf
   *
   * @param ticks
   */
  zoomOut(ticks?: number) {
    let newScale: any = this.currentScale;
    do {
      newScale = (newScale / this.DEFAULT_SCALE_DELTA).toFixed(2);
      newScale = Math.floor(newScale * 10) / 10;
      newScale = Math.max(this.MIN_SCALE, newScale);
    } while (--ticks > 0 && newScale > this.MIN_SCALE);
    this.currentScaleMode = 'auto';
    this.setScaleUpdatePages(newScale);
  }

  /**
   * load the previous page
   */
  previousPage() {
    if (this.pdfViewer && this.page > 1) {
      this.page--;
      this.displayPage = this.page;

      this.pdfViewer.currentPageNumber = this.page;
    }
  }

  /**
   * load the next page
   */
  nextPage() {
    if (this.pdfViewer && this.page < this.totalPages) {
      this.page++;
      this.displayPage = this.page;

      this.pdfViewer.currentPageNumber = this.page;
    }
  }

  /**
   * load the page in input
   *
   * @param page to load
   */
  inputPage(page: string) {
    const pageInput = parseInt(page, 10);

    if (!isNaN(pageInput) && pageInput > 0 && pageInput <= this.totalPages) {
      this.page = pageInput;
      this.displayPage = this.page;
      this.pdfViewer.currentPageNumber = this.page;
    } else {
      this.displayPage = this.page;
    }
  }

  /**
   * Page Change Event
   *
   * @param event
   */
  onPageChange(event) {
    this.page = event.pageNumber;
    this.displayPage = event.pageNumber;
  }

  onPdfPassword(callback, reason) {
    this.dialog
      .open(PdfPasswordDialogComponent, {
        width: '400px',
        disableClose: true,
        data: { reason }
      })
      .afterClosed()
      .subscribe(password => {
        if (password) {
          callback(password);
        }
      });
  }

  /**
   * Page Rendered Event
   */
  onPagerendered() {
    this.rendered.emit();
  }

  /**
   * Litener Keyboard Event
   * @param event KeyboardEvent
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const key = event.keyCode;
    if (key === 39) {
      // right arrow
      this.nextPage();
    } else if (key === 37) {
      // left arrow
      this.previousPage();
    }
  }

  public comment() {
    const dialogRef = this.dialog.open(DialogCommentComponent, {
      width: '40%',
      height: '30%',
      data: {
        elementId: this.elementId
      }
    });
  }

  addComment() {
    const queries = '?reverse=true&startIndex=0&pageSize=10';
    const data = {
      content: this.commentaire
    };
    this.commentService.createComment(data, this.elementId).then(
      res => {
        this.comments.push(res.item);
        this.commentaire = '';
      },
      err => {
      }
    );
  }

  delete(comment: any) {
    const commentToDelete = comment.name;
    let msg: string;
    if (this.storage.lang === 'fr') {
      msg = 'Souhaitez-vous réellement supprimer le commentaire  ?';
    } else if (this.storage.lang === 'en') {
      msg = 'Do you really want to delete the comment ?';
    }
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '40%',
      height: '20%',
      data: {
        text: msg
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.commentService.deleteComment(commentToDelete).then(res => {
          this.comments.splice(this.comments.indexOf(comment), 1);
        });
      }
    });
  }

  public showplus() {
    this.show = !this.show;

    // CHANGE THE NAME OF THE BUTTON.
    if (this.show) {
      if (localStorage.getItem('lang') === 'fr') {
        this.buttonName = 'Fermer';
      } else {
        this.buttonName = 'Close';
      }
    } else {
      this.buttonName = 'Plus...';
    }
  }



  getHightlightCoords() {
    var pageIndex = this.pdfViewer.currentPageNumber - 1;
    var page = this.pdfViewer.getPageView(pageIndex);
    var pageRect = page.canvas.getClientRects()[0];
    var selectionRects = window.getSelection().getRangeAt(0).getClientRects();
    var selectionRectsList = Object.values(selectionRects);
    var viewport = page.viewport;
    var selected = selectionRectsList.map((r) => {
      return viewport.convertToPdfPoint(r.left - pageRect.x, r.top - pageRect.y).concat(
        viewport.convertToPdfPoint(r.right - pageRect.x, r.bottom - pageRect.y));
    });

    return { page: pageIndex, coords: selected };
  }


  showHighlight(selected) {
    var pageIndex = selected.page;
    var page = this.pdfViewer.getPageView(pageIndex);
    var pageElement = page.canvas.parentElement;
    var viewport = page.viewport;
    selected.coords.forEach(function (rect) {
      var bounds = viewport.convertToViewportRectangle(rect);
      var el = document.createElement('div');
      el.setAttribute('style', 'position: absolute; background-color: pink;' +
        'left:' + Math.min(bounds[0], bounds[2]) + 'px; top:' + Math.min(bounds[1], bounds[3]) + 'px;' +
        'width:' + Math.abs(bounds[0] - bounds[2]) + 'px; height:' + Math.abs(bounds[1] - bounds[3]) + 'px;');
      pageElement.appendChild(el);
    });
  }
}